import { RawGroupingData } from "./types";

class GroupingSummaryModel {
  id: string;
  name: string;
  image: string;
  itemId: string;
  listingIds: string[];
  status: string;
  
  constructor(rawGroupingData: RawGroupingData) {
    this.id = rawGroupingData.id;
    this.name = rawGroupingData.name;
    this.status = rawGroupingData.status;
    this.itemId = rawGroupingData.item_id;
    this.listingIds = rawGroupingData.listings;
    this.image = rawGroupingData.image;
  }

  getProcessCardFormat() {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
      image: this.image,
      baseType: 'Listings',
      baseCount: this.listingIds.length
    }
  }
}

export default GroupingSummaryModel;
